<template>
  <footer class="bg-pawbook-black">

    <!-- ── Main grid ── -->
    <div class="mx-auto max-w-6xl px-6 pb-12 pt-16 md:px-10">
      <div class="grid grid-cols-1 gap-14 sm:grid-cols-2 lg:grid-cols-4 lg:gap-10">

        <!-- Col 1: Logo + download -->
        <div class="sm:col-span-2 lg:col-span-1">
          <NuxtLink :to="$localePath('/')" class="mb-8 inline-block">
            <NuxtImg src="/logo.svg" alt="Bubba" width="200" height="52" class="h-14 w-auto brightness-0 invert" />
          </NuxtLink>
          <AppStoreBadges :width="160" :gap="3" vertical />
        </div>

        <!-- Col 2: Bubba links -->
        <div>
          <h4 class="mb-5 text-xs font-semibold uppercase tracking-widest text-white/30">{{ $t('landing.footer.bubba') }}</h4>
          <ul class="space-y-4">
            <li><NuxtLink :to="$localeRoute('/services')" class="text-base font-medium text-white/60 transition-colors hover:text-white">{{ $ts('nav.services') }}</NuxtLink></li>
            <li><NuxtLink :to="$localeRoute('/vet')" class="text-base font-medium text-white/60 transition-colors hover:text-white">{{ $ts('nav.onlineVet') }}</NuxtLink></li>
            <li><NuxtLink :to="$localeRoute('/partners')" class="text-base font-medium text-white/60 transition-colors hover:text-white">{{ $ts('landing.footer.partners') }}</NuxtLink></li>
            <li><NuxtLink :to="$localeRoute('/blog')" class="text-base font-medium text-white/60 transition-colors hover:text-white">{{ $ts('nav.blog') }}</NuxtLink></li>
            <li><NuxtLink :to="$localeRoute('/download')" class="text-base font-medium text-white/60 transition-colors hover:text-white">{{ $t('landing.footer.download') }}</NuxtLink></li>
          </ul>
        </div>

        <!-- Col 3: Company -->
        <div>
          <h4 class="mb-5 text-xs font-semibold uppercase tracking-widest text-white/30">{{ $ts('landing.footer.company') }}</h4>
          <ul class="space-y-4">
            <li><NuxtLink :to="$localeRoute('/about')" class="text-base font-medium text-white/60 transition-colors hover:text-white">{{ $ts('landing.footer.aboutUs') }}</NuxtLink></li>
            <li><NuxtLink :to="$localeRoute('/contact')" class="text-base font-medium text-white/60 transition-colors hover:text-white">{{ $ts('landing.footer.contactUs') }}</NuxtLink></li>
          </ul>
        </div>

        <!-- Col 4: Social + locale -->
        <div>
          <h4 class="mb-5 text-xs font-semibold uppercase tracking-widest text-white/30">{{ $t('landing.footer.followUs') }}</h4>
          <div class="flex items-center gap-5">
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" class="text-white/50 transition-colors hover:text-white">
              <Icon name="line-md:instagram" size="36" />
            </a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" class="text-white/50 transition-colors hover:text-white">
              <Icon name="line-md:facebook" size="36" />
            </a>
            <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" class="text-white/50 transition-colors hover:text-white">
              <Icon name="line-md:tiktok" size="36" />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" class="text-white/50 transition-colors hover:text-white">
              <Icon name="line-md:youtube" size="36" />
            </a>
          </div>

          <div class="mt-10">
            <LocaleSwitch dark expand-direction="up" />
          </div>
        </div>

      </div>
    </div>

    <!-- ── Bottom bar ── -->
    <div class="border-t border-white/[0.07]">
      <div class="mx-auto flex max-w-6xl flex-wrap items-center gap-5 px-6 py-4 text-xs text-white/30 md:px-10">
        <span>{{ copyrightText }}</span>
        <NuxtLink :to="$localeRoute('/legal/privacy-policy')" class="transition-colors hover:text-white/60">{{ $t('landing.footer.privacy') }}</NuxtLink>
        <NuxtLink :to="$localeRoute('/legal/cookie-policy')" class="transition-colors hover:text-white/60">{{ $t('landing.footer.cookies') }}</NuxtLink>
        <NuxtLink :to="$localeRoute('/legal')" class="transition-colors hover:text-white/60">{{ $ts('landing.footer.legalNotice') }}</NuxtLink>
      </div>
    </div>

  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from '#imports';

const { $t, $ts, $localePath, $localeRoute } = useI18n();

const currentYear = new Date().getFullYear();
const copyrightText = computed(() => {
  const template = $ts('landing.footer.copyright') as string;
  return template.replace('{year}', String(currentYear));
});
</script>
